function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.351 6.742l-2.256.183a.173.173 0 01-.188-.204L11.224.205c.034-.171-.185-.277-.305-.147L3.045 8.639c-.106.116-.012.298.146.285l2.257-.183c.117-.01.21.092.188.204L4.319 15.46c-.034.17.185.277.305.147l7.874-8.581c.106-.116.012-.298-.147-.285z",
  fill: "currentColor"
})));